import React from 'react';
import { ChipField, useTranslate } from 'react-admin';

export const TagsListField = ({ record = {}, source }) => {
  const t = useTranslate();
  return record[source] && record[source].map(item => <ChipField record={{ item: t(item) }} source="item" key={item} />);
};
